<!--  -->
<template>
  <div 
    class="tem-head"
  >
    <span class="tem-head__img" :style="setBgImg(globalConfig.titleElements[0])"></span>
    
    <span class="tem-head__text" :style="setStyle('main','color')">{{ text }}</span>
    <span class="tem-head__img" :style="setBgImg(globalConfig.titleElements[1])"></span>
  </div>
</template>

<script>
import {setColor,setBgImgStyle} from '../utils/style'
export default {
  props: {
    main: {
      type: String,
      default: '#000'
    },
    titleElements: {
      type: Array,
      default: () => [
        'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=3314399767,4118363287&fm=26&gp=0.jpg',
        'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=3314399767,4118363287&fm=26&gp=0.jpg'
      ]
    },
    globalConfig:{
      type:Object,
      default:()=>{}
    },
    text: {
      type: String,
    },
    
  },
  computed: {
   
  },
  methods:{
    setStyle(key, type) {
      return setColor(this.globalConfig, key, type);
    },
    setBgImg(url) {
      return url && setBgImgStyle(url);
    },
  },
}

</script>
<style lang='less' scoped>
.tem-head {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height:50px;
  line-height: 50px;
  text-align: center;
  font-size: 24px;
  font-family:PingFang SC;
  font-weight:600;
  color:rgba(252,241,213,1);
  &__text {
    margin: 0 20px;
  }
  &__img {
    width: 40px;
    height: 21px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}
</style>